// Debug: Log the API base URL to verify environment at runtime
import * as Sentry from '@sentry/react';
export var initSentry = function (history) {
    var dsn = process.env.REACT_APP_SENTRY_DSN;
    if (!dsn) {
        return;
    }
    var getEnvironment = function () {
        var apiUrl = process.env.REACT_APP_API_BASE_URL || '';
        if (apiUrl.includes('uat')) {
            return 'uat';
        }
        return 'production';
    };
    try {
        Sentry.init({
            dsn: dsn,
            environment: getEnvironment(),
            release: 'handheld@0.1.0',
            sendDefaultPii: true,
            tracePropagationTargets: [
                "https://uat.fulfillmentplusny.com",
                "https://omega.fulfillmentplusny.com",
            ],
            integrations: [
                history
                    ? Sentry.reactRouterV5BrowserTracingIntegration({ history: history })
                    : Sentry.browserTracingIntegration(),
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: false,
                    maskAllInputs: true,
                    block: ['.sensitive', '[data-sensitive]'],
                    mask: ['[type="password"]', '[data-mask]'],
                }),
            ],
            tracesSampleRate: 1.0,
            replaysSessionSampleRate: 0.1,
            replaysOnErrorSampleRate: 1.0,
            maxBreadcrumbs: 50,
            maxValueLength: 1000,
            attachStacktrace: true,
            beforeBreadcrumb: function (breadcrumb) {
                if (breadcrumb.category === 'console') {
                    return null;
                }
                return breadcrumb;
            },
            beforeSend: function (event) {
                var _a;
                var apiUrl = process.env.REACT_APP_API_BASE_URL || '';
                if (apiUrl.includes('uat')) {
                    event.environment = 'uat';
                }
                else {
                    event.environment = 'production';
                }
                if (event.request) {
                    if (event.request.headers) {
                        delete event.request.headers.moquiSessionToken;
                        delete event.request.headers.Authorization;
                    }
                    if (event.request.data) {
                        var data = typeof event.request.data === 'string'
                            ? JSON.parse(event.request.data)
                            : event.request.data;
                        if (data.password)
                            delete data.password;
                        if (data.moquiSessionToken)
                            delete data.moquiSessionToken;
                        event.request.data = typeof event.request.data === 'string'
                            ? JSON.stringify(data)
                            : data;
                    }
                }
                if ((_a = event.contexts) === null || _a === void 0 ? void 0 : _a.localStorage) {
                    delete event.contexts.localStorage.moquiSessionToken;
                    delete event.contexts.localStorage.loggedInHH;
                }
                return event;
            },
            ignoreErrors: [
                'top.GLOBALS',
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'atomicFindClose',
                'NetworkError',
                'Network request failed',
                'ResizeObserver loop limit exceeded',
                'ResizeObserver loop completed',
                'Non-Error promise rejection captured',
            ],
        });
    }
    catch (error) {
    }
};
export var setSentryUser = function (user) {
    Sentry.setUser({
        id: user.id,
        email: user.email,
        username: user.username,
    });
    if (user.organizationId) {
        Sentry.setTag('organization', user.organizationId);
    }
    if (user.facilityId) {
        Sentry.setTag('facility', user.facilityId);
    }
};
export var clearSentryUser = function () {
    Sentry.setUser(null);
    Sentry.setTag('organization', null);
    Sentry.setTag('facility', null);
};
